// based on this list from facebook
// https://developers.facebook.com/docs/messenger-platform/messenger-profile/supported-locales/

const localeList = {
  en: 'en_US',
  ja: 'ja_JP',
  vi: 'vi_VN',
  zhcn: 'zh_CN',
  zhtw: 'zh_TW',
  de: 'de_DE',
  es: 'es_ES',
  fr: 'fr_FR',
  hi: 'hi_IN',
  id: 'id_ID',
  it: 'it_IT',
  nl: 'nl_NL',
  pt: 'pt_PT',
  ru: 'ru_RU',
};

const getLocale = (language) => {
  return localeList[language] || localeList.en;
};

export default getLocale;



// WEBPACK FOOTER //
// ../src/utils/getLocale.js